<template>
    <b-navbar
    :fixed-top="false" 
    :mobile-burger="false" 
    :transparent="true" 
    :style="storeNavStyle">
        <template slot="brand">
            <b-navbar-item 
            href="/">
                <img
                    :src="logo"
                    style="max-height:65px;"
                    alt="logo"
                >
            </b-navbar-item>
        </template>
        
        <template slot="start">

        </template>
        
        <template slot="end">
            <b-navbar-item href="/">
                Home
            </b-navbar-item>

            <b-navbar-item v-if="blogBool && blogPowerUp == 'True'" :href="blogUrl">
                Blog
            </b-navbar-item>
            
            <b-dropdown v-if="isStore" position="is-bottom-left">
                <a
                    class="navbar-item"
                    slot="trigger"
                    role="button">
                    <span>Productos</span>
                    <b-icon icon="menu-down"></b-icon>
                </a>
                <b-dropdown-item
                    aria-role="menu-item"
                    class="category-nav"
                    :focusable="false"
                    custom
                    paddingless>
                    <b-tabs type="is-boxed" position="is-left" vertical >
                        
                        <b-tab-item v-for="cat in categories" v-if="cat.hideEmpty" :label="cat.title" :key="cat.id">
                            <div class="tags">
                                
                                <a 
                                v-for="sub in cat.subcategories" 
                                :key="sub.id"
                                class="tag is-rounded is-medium is-custom"
                                rounded
                                :href="sub.getProdListUrl">{{sub.title}}</a>
                            </div>
                            <div class="tags">
                                <a 
                                class="is-text-bold" 
                                :href="cat.getProdListUrl">
                                    Ver todos >>>
                                </a>
                            </div>
                        </b-tab-item>
                    </b-tabs>
                    <b-navbar-item :href="generalCatalogUrl">
                        Ver todos
                    </b-navbar-item>
                </b-dropdown-item>
                    
            </b-dropdown>

            <b-navbar-item :href="contactUrl">
                Contacto
            </b-navbar-item>

            <b-navbar-item v-if="faqsBool" :href="faqsUrl">
                Preguntas frecuentes
            </b-navbar-item>
            
            <b-navbar-item
            v-if="isB2b && loggedUser">
                <a
                :href="pedidosUrl"
                rounded
                class="button is-custom"
                >
                Hacer Pedido
                </a>
            </b-navbar-item>
            
            <b-navbar-item
            v-for="x in navPages"
            v-if="x.inNav"
            :key="x.id"
            :href="x.getPublicDetail">
                {{x.title}}
            </b-navbar-item>
            
        </template>
    </b-navbar>
</template>

<script>

export default {

    props:{
        topNavFixed:{
            type:Boolean,
            default:false
        },
        storeNavStyle:{
            type:Object,
            default:new Object({})
        },
        logo:{
            type:String,
            default:""
        },
        searchEndpoint:{
            type:String,
            default:""
        },
        searchResultsUrl:{
            type:String,
            default:""
        },
        categories:{
            type:Array,
            default: new Array([])
        },
        contactUrl:{
            type:String,
            default:""
        },
        cartDetail:{
            type:String,
            default:""
        },
        cartCount:{
            type:Number,
            default:0
        },
        loggedUser:{
            type:Boolean,
            default:false
        },
        userSettings:{
            type:String,
            default:""
        },
        logoutUrl:{
            type:String,
            default:""
        },
        registerUrl:{
            type:String,
            default:""
        },
        loginUrl:{
            type:String,
            default:""
        },
        isStore:{
            type:Boolean,
            default:false
        },
        isContent:{
            type:Boolean,
            default:false
        },
        isB2b:{
            type:Boolean,
            default:false
        },
        pedidosUrl:{
            type:String,
            default:""
        },
        faqsBool:{
            type:Boolean,
            default:false
        },
        faqsUrl:{
            type:String,
            default:""
        },
        blogBool:{
            type:Boolean,
            default:false
        },
        blogUrl:{
            type:String,
            default:""
        },
        blogPowerUp:{
            type:String,
            default:""
        },
        navPages:{
            type:Array,
            default: new Array([])
        },
        generalCatalogUrl:{
            type:String,
            default:""
        }
    },
    methods:{
        goToSeeAllProducts(){
            window.location.href = this.generalCatalogUrl
        }
    }
}
</script>

<style lang="scss" scoped>
.category-nav{
    width: 700px;
    max-height: 500px;
    overflow-y: scroll;
    margin: 0px auto;
    z-index:900;
}

a.navbar-item:hover{
    color:var(--primary) !important;
}

a.navbar-item:active{
    color:var(--primary) !important;
}

a.navbar-item:focus{
    color:var(--primary) !important;
}


a.navbar-link:hover{
    color:var(--primary) !important;
}

a.navbar-link:active{
    color:var(--primary) !important;
}

a.navbar-link:focus{
    color:var(--primary) !important;
}
.navbar-brand{
    .icon{
        color:var(--primary) ;
    }
}
.navbar-end{
    .navbar-item{
        .navbar-link:hover{
            color:var(--primary) !important;
        }
    }
}
.is-block{
    color: red;
}

.is-custom{
    background: var(--primary);
    color: var(--text-color)
}

.cat-card{
    margin-bottom:5px;
    border:0px #fff solid !important;
    border-radius: 20px;
    box-shadow: 1px 2px 10px rgba(184, 184, 184, 0.45);
    .card-header{
        box-shadow: 0px 0px #fff;
        border:0px #fff solid !important;
    }
}
</style>